module.exports = __webpack_public_path__ + "img/pic-2.0acc278f.png";